import { render, staticRenderFns } from "./Mutation.vue?vue&type=template&id=485a7a4d"
import script from "./Mutation.vue?vue&type=script&lang=js"
export * from "./Mutation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports